import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.057 1.75c2.19 0 3.912 0 5.255.18 1.377.186 2.469.573 3.327 1.43.858.86 1.245 1.951 1.43 3.328.181 1.343.181 3.064.181 5.255v.114c0 2.19 0 3.912-.18 5.255-.186 1.377-.573 2.469-1.43 3.327-.86.858-1.951 1.245-3.328 1.43-1.343.181-3.064.181-5.255.181h-.114c-2.19 0-3.912 0-5.255-.18-1.377-.186-2.469-.573-3.327-1.43-.858-.86-1.245-1.951-1.43-3.328-.181-1.343-.181-3.064-.181-5.255v-.114c0-2.19 0-3.912.18-5.255.186-1.377.573-2.469 1.43-3.327.86-.858 1.951-1.245 3.328-1.43 1.343-.181 3.064-.181 5.255-.181zm4.619 6.513a1 1 0 0 1 .061 1.413l-5.5 6a1 1 0 0 1-1.444.031l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.762 1.761 4.794-5.23a1 1 0 0 1 1.413-.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }